"use client";

import { useQuery } from "@tanstack/react-query";
import apiFetch from "@/lib/fetch";

interface SiteCompaniesResponse {
  globalDiscount?: number | null;
}

/**
 * The site's company discount rate, set in the panel under
 * "Sitelere Atanan Şirketler → İndirim Oranı". Returns null when the site has
 * no rate (or the backend doesn't send it yet).
 */
export function useSiteCompanyGlobalDiscount(enabled = true): number | null {
  const { data } = useQuery<SiteCompaniesResponse>({
    queryKey: ["site-company-global-discount"],
    queryFn: () => apiFetch({ route: "company/all?index=0" }),
    enabled,
    staleTime: 1000 * 60 * 60,
  });

  const discount = Number(data?.globalDiscount);
  return Number.isFinite(discount) && discount > 0 ? discount : null;
}
